export default {"src":"/uk/_next/static/media/transferAndContributionBreakdownIcon.0aad1d36.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};